<router-outlet></router-outlet>
<div id="single-spa-application:new-mini-apps"></div>
